/**
 * Default post-login / authed landing route by role and permissions.
 * Employee profile routes use users.id (not employees.id).
 */
import { isRegularUserRole } from '@/utils/systemRoles';

function hasAnyPermission(permissions, codes) {
  if (!Array.isArray(codes) || codes.length === 0) return true;
  if (!Array.isArray(permissions)) return false;
  return codes.some((code) => permissions.includes(code));
}

export function getDefaultAuthedRoute(user) {
  if (!user?.id) {
    return { name: 'login' };
  }

  const roles = user.roles || [];
  const permissions = user.permissions || [];

  if (isRegularUserRole(roles)) {
    return { name: 'my-profile' };
  }

  if (hasAnyPermission(permissions, ['dashboard.view.global', 'dashboard.view.department'])) {
    return { name: 'dashboard' };
  }

  if (hasAnyPermission(permissions, ['employees.view.global', 'employees.view.department'])) {
    return { name: 'employees' };
  }

  if (hasAnyPermission(permissions, ['departments.view.global', 'departments.view.department'])) {
    return { name: 'departments' };
  }

  if (hasAnyPermission(permissions, ['positions.view.global', 'positions.view.department'])) {
    return { name: 'positions' };
  }

  if (
    hasAnyPermission(permissions, [
      'compensation.view_all',
      'compensation.view_us',
      'compensation.view'
    ])
  ) {
    return { name: 'compensation' };
  }

  if (
    hasAnyPermission(permissions, [
      'candidates.view.global',
      'candidates.view_deleted.global'
    ])
  ) {
    return { name: 'candidates' };
  }

  return { name: 'my-profile' };
}
